module.exports = __webpack_public_path__ + "static/media/limpieza-&-spa.7096bdf0.png";